import { parseRef } from "../../firebase"
import { defaultListener } from "../helper"

export default {
  state: {
    tenants: {}
  },
  getters: {
    getMyTenants(state, getters) {
      const tenantIds = getters.getUserTenants

      return  Object.values(state.tenants)
        .filter(tenant => tenantIds.includes(tenant.id))
    },
    getTenant: (state) => (id) => {
      return state.tenants[id]
    },
    getActiveTenant: (state, getters) => {
      const id = getters.getSessionTenant

      return state.tenants[id]
    }
  },
  actions: {
    initTenants({ commit, getters }){
      const tenantIds  = getters.getUserTenants

      tenantIds.forEach(tenantId => {
        this.$firebase.firestore()
          .collection('tenants')
          .doc(tenantId)
          .onSnapshot(defaultListener.bind(this, commit, 'ADD_TENANT', 'REMOVE_TENANT'),
            e => console.log(e))
      })
    },
    updateTenant({ }, data) {
      const { timezone } = data
      const payload = { timezone }

      return this.$api.patch('/api/tenant', payload)
    },
    async createTenantUser({  }, data) {
      const { firstName, lastName, email, phoneNumber, role, sendInvite } = data
      const payload = { firstName, lastName, email, phoneNumber, role, sendInvite }
      await this.$api.post('/api/tenant/user', payload)
        .catch(e => console.log(e))
    },
    async deleteTenantUser({  }, data) {
      const { id } = data
      await this.$api.delete(`/api/tenant/user/${id}`)
        .catch(e => console.log(e))
    },
  },
  mutations: {
    ADD_TENANT(state, tenant){
      const { id } = tenant

      if (id) {
        const newState = { ...state.tenants }
        newState[ id ] = tenant
        state.tenants = newState
      }
    },
    REMOVE_TENANT(state, id) {
      if (state.tenants[ id ]) {
        const newState = { ...state.tenants }
        delete newState[ id ]
        state.tenants = newState
      }
    }
  },
}
